import React from 'react';
import DataTypes from '../../../components/Table/dataTypes';
import { ppsiInProgressRoute, ppsiPublishedRoute } from '../../../routes';
import { EnrichmentData } from '../constants';
import UpdatesIcon from '../../../components/common/UpdatesIcon';

const formatFormulaCode = (formulaCode, version) => {
  return `${formulaCode.substring(0, 3)} ${formulaCode.substring(
    3,
    7
  )} ${formulaCode.substring(7, formulaCode.length)}\\${version}`;
};

const ppsiColumns = enrichmentDataType => ({
  PresentationName: {
    name: 'presentationName',
    dataField: `${enrichmentDataType}.{language}.presentationName`,
    label: 'Product Name',
    translatable: true,
    link: rowData =>
      enrichmentDataType === EnrichmentData.IN_PROGRESS
        ? ppsiInProgressRoute(rowData.id)
        : ppsiPublishedRoute(rowData.id),
    width: 600
    // grow: 4
  },
  Formula: {
    name: 'formula',
    label: 'iFood Formula',
    // Used for sorting. Improve to consider the composed value.
    dataField: 'formulaCode',
    calculateCellValue: data => `${data.formulaCode}\\${data.formulaVersion}`,
    width: 130,
    grow: 0,
    shrink: 0
  },
  IfoodID: {
    name: 'ifoodID',
    label: 'iFood ID',
    // Used for sorting. Improve to consider the composed value.
    // dataField: 'formulaCode',
    calculateCellValue: data =>
      formatFormulaCode(data.formulaCode, data.formulaVersion),
    width: 135,
    grow: 0,
    shrink: 0
  },
  LifeCycleStatus: {
    name: 'lifecycleStatus',
    // dataField: 'lifecycleStatus',
    calculateCellValue: rowData => {
      return (
        rowData.inProgressPpsiEnrichmentData.referencedIFoodData
          .lifecycleStatus || ''
      );
    },
    // dataType: DataTypes.Date,
    label: 'Lifecycle Status'
    // searchable: false,
    // width: 280
    // grow: 0
  },
  LifeCycleStatusForPublished: {
    name: 'lifecycleStatus',
    // dataField: 'lifecycleStatus',
    calculateCellValue: rowData => {
      return (
        rowData.publishedPpsiEnrichmentData.referencedIFoodData
          .lifecycleStatus || ''
      );
    },
    // dataType: DataTypes.Date,
    label: 'Lifecycle Status',
    // searchable: false,
    width: 280
    // grow: 0
  },
  ModifyDate: {
    name: 'modifyDate',
    dataField: `${enrichmentDataType}.modifyDate`,
    dataType: DataTypes.Date,
    label: 'Modify Date',
    searchable: false
    // width: 125,
    // grow: 0,
    // shrink: 0
  },
  ModifiedBy: {
    name: 'modifiedBy',
    dataField: `${enrichmentDataType}.lastModifiedBy`,
    label: 'Modified By'
    // width: 250
  },
  Status: {
    name: 'status',
    dataField: `${enrichmentDataType}.status`,
    label: 'Status',
    width: 100
  },
  PiaNumber: {
    name: 'piaNumber',
    dataField: `${enrichmentDataType}.referencedIFoodData.piaArticleNumber`,
    label: 'PIA Number'
    // width: 120,
    // grow: 0,
    // shrink: 0
  },
  TargetPublishDate: {
    name: 'targetPublishDate',
    dataField: `${enrichmentDataType}.targetPublishDate`,
    dataType: DataTypes.Date,
    label: 'Target Publish Date',
    searchable: false,
    width: 200,
    grow: 0,
    shrink: 0
  },
  ActualApprovalDate: {
    name: 'actualApprovalDate',
    dataField: `${enrichmentDataType}.actualApprovalDate`,
    dataType: DataTypes.Date,
    label: 'Submitted Date',
    searchable: false,
    width: 130,
    grow: 0,
    shrink: 0
  },
  ApprovedBy: {
    name: 'approveBy',
    dataField: `${enrichmentDataType}.approveBy`,
    label: 'Scheduled By',
    width: 280
  },
  ActualPublishDate: {
    name: 'actualPublishDate',
    dataField: `${enrichmentDataType}.actualPublishedDate`,
    dataType: DataTypes.Date,
    label: 'Publishing Date',
    searchable: false,
    width: 150,
    grow: 0,
    shrink: 0
  },
  PublishedBy: {
    name: 'publishedBy',
    dataField: `${enrichmentDataType}.publishBy`,
    label: 'Published By',
    width: 300
  },
  Version: {
    name: 'version',
    dataField: `${enrichmentDataType}.version`,
    label: 'Version',
    width: 75,
    grow: 0,
    shrink: 0
  },
  RangeCategory: {
    name: 'rangeCategory',
    dataField: `${enrichmentDataType}.referencedIFoodData.piaProductAreaName`,
    label: 'Product Area',
    filterable: true,
    width: 350
  },
  Updates: {
    name: 'updates',
    CellValue: ({ rowData }) => {
      const { upToDate, updateNotificationList } = rowData.data[
        enrichmentDataType
      ];
      return (
        !upToDate && (
          <UpdatesIcon
            message={updateNotificationList
              .map(notification => notification.message)
              .join(',')}
          />
        )
      );
    },
    label: 'Updates'
    // width: 60,
    // grow: 0,
    // shrink: 0
  }
});

export default ppsiColumns;
